var React = require('react');

function PieChart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M23 2C11.414 2 2 11.414 2 23v1h22V2h-1zm-1 2.1V22H4.1A18.889 18.889 0 0122 4.1zM27 6c-.338 0-.666.035-1 .05v2c.333-.017.662-.05 1-.05 10.477 0 19 8.523 19 19s-8.523 19-19 19S8 37.477 8 27c0-.338.033-.667.05-1h-2c-.015.334-.05.662-.05 1 0 11.58 9.42 21 21 21s21-9.42 21-21S38.58 6 27 6z"}));
}

PieChart.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = PieChart;

PieChart.default = PieChart;
